'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var parseMs = _interopDefault(require('parse-ms'));

/**
 * Calculate remaining time respecting server time offset
 * @param {number} offset - Server time offset
 * @param {number} end - End of time range
 * @param {number} start - Start of time range
 *
 * @returns {object} contains: days, hours, minutes, seconds, milliseconds }
 */

function toRemainingTime(offset, end, start) {
  return parseMs(offset + end - start);
}

exports.toRemainingTime = toRemainingTime;
//# sourceMappingURL=to-remaining-time.js.map
